export default {
  'aiBilling.title': 'AI Billing',
  'aiBilling.back': 'Volver',
  'aiBilling.description':
    'Configure el perfil de facturación, límites, periodos presupuestarios y créditos.',

  'aiBilling.tabs.profile': 'Perfil',
  'aiBilling.tabs.limits': 'Límites',
  'aiBilling.tabs.periods': 'Periodos',
  'aiBilling.tabs.grants': 'Créditos',

  'aiBilling.validation.required': 'Este campo es obligatorio.',
  'aiBilling.validation.invalidEmails': 'Uno o más correos no tienen un formato válido.',
  'aiBilling.validation.amountGreaterThanZero': 'El monto debe ser mayor que 0.',

  'aiBilling.text.active': 'Activo',
  'aiBilling.text.inactive': 'Inactivo',

  'aiBilling.profile.billingMode': 'Modo de facturación',
  'aiBilling.profile.budgetEditMode': 'Modo de edición de presupuesto',
  'aiBilling.profile.currency': 'Moneda',
  'aiBilling.profile.isBudgetEnabled': 'Presupuesto habilitado',
  'aiBilling.profile.monthlyIncludedCreditOverrideAmount': 'Crédito incluido mensual personalizado',
  'aiBilling.profile.notifyMonthlyCreditGranted': 'Notificar crédito mensual otorgado',
  'aiBilling.profile.alertEmails': 'Correos de alerta',
  'aiBilling.profile.monthlyBudgetAmount': 'Monto de presupuesto mensual',
  'aiBilling.profile.maxSelfServiceBudgetAmount': 'Monto máximo de presupuesto en autoservicio',
  'aiBilling.profile.budgetExceededBehavior': 'Comportamiento al exceder presupuesto',

  'aiBilling.billingMode.creditCard': 'Tarjeta de crédito',
  'aiBilling.billingMode.manualBilling': 'Facturación manual',

  'aiBilling.budgetEditMode.selfService': 'Autoservicio',
  'aiBilling.budgetEditMode.requiresAutomyApproval': 'Requiere aprobación de Automy',
  'aiBilling.budgetEditMode.automyOnly': 'Solo Automy',

  'aiBilling.budgetExceededBehavior.blockUsage': 'Bloquear uso',
  'aiBilling.budgetExceededBehavior.allowWithWarning': 'Permitir con advertencia',

  'aiBilling.currency.usd': 'USD',

  'aiBilling.limits.monthlyBudget': 'Presupuesto mensual',
  'aiBilling.limits.monthlyBudgetAmount': 'Monto de presupuesto mensual',
  'aiBilling.limits.alerts': 'Alertas',
  'aiBilling.limits.addAlert': 'Agregar alerta',
  'aiBilling.limits.addAlert.description':
    'Configure el umbral de consumo y los destinatarios de notificación para esta alerta.',
  'aiBilling.limits.editAlert': 'Editar alerta',
  'aiBilling.limits.editAlert.description':
    'Actualice el umbral, los destinatarios o la configuración de notificación de esta alerta.',
  'aiBilling.limits.sendToOrganizationOwners': 'Enviar a propietarios de la organización',
  'aiBilling.limits.budgetDisabled':
    'El presupuesto está deshabilitado en el perfil. Active el presupuesto para editar límites.',
  'aiBilling.limits.deleteConfirm.title': 'Eliminar alerta',
  'aiBilling.limits.deleteConfirm.content': '¿Desea eliminar esta alerta de consumo?',

  'aiBilling.limits.columns.threshold': 'Umbral',
  'aiBilling.limits.fields.thresholdPercentage': 'Umbral (%)',
  'aiBilling.limits.columns.emailSubjectPrefix': 'Prefijo del asunto',
  'aiBilling.limits.columns.emails': 'Correos',

  'aiBilling.periods.filter.status': 'Filtrar por estado',
  'aiBilling.periods.columns.period': 'Periodo',
  'aiBilling.periods.columns.budget': 'Consumo / presupuesto',
  'aiBilling.periods.columns.aiUsage': 'Uso IA / presupuesto',
  'aiBilling.periods.columns.credit': 'Crédito consumido / otorgado',
  'aiBilling.periods.columns.includedCredit': 'Crédito incluido',
  'aiBilling.periods.columns.promotionalCredit': 'Promocional',
  'aiBilling.periods.columns.paidCredit': 'Crédito pagado',
  'aiBilling.periods.columns.crossPeriodMovements': 'Movimientos entre períodos',
  'aiBilling.periods.columns.billableAmount': 'Monto facturable',
  'aiBilling.periods.columns.periodStart': 'Inicio',
  'aiBilling.periods.columns.periodEnd': 'Fin',

  'aiBilling.periods.aiUsage.ofBudget': 'de {budget}',
  'aiBilling.periods.credit.available': 'disponible',
  'aiBilling.periods.credit.unused': 'no utilizado',
  'aiBilling.periods.credit.expired': 'expirado',
  'aiBilling.periods.credit.consumedOfGranted': '{consumed} de {granted} consumido',
  'aiBilling.periods.movements.appliedTo': '{amount} aplicado a {period}',
  'aiBilling.periods.movements.receivedFrom': '{amount} recibido desde {period}',
  'aiBilling.periods.movements.appliedToOther': '{amount} aplicado a otros períodos',
  'aiBilling.periods.movements.receivedFromOther': '{amount} recibido desde otros períodos',
  'aiBilling.periods.movements.moreCount': '+{count} más',

  'aiBilling.periods.tooltip.aiUsage':
    'Uso de IA ocurrido durante el período. No incluye créditos ni traspasos.',
  'aiBilling.periods.tooltip.includedConsumed':
    'Crédito incluido consumido del grant originado en este período. Puede incluir importes aplicados a períodos anteriores.',
  'aiBilling.periods.tooltip.appliedToOther':
    'Parte del crédito consumido aplicada a otro período. Es un desglose; no se resta otra vez del consumido.',
  'aiBilling.periods.tooltip.receivedFromOther':
    'Crédito recibido desde grants originados en otros períodos.',
  'aiBilling.periods.tooltip.billable':
    'Monto a facturar tras aplicar créditos. Puede ser mayor que cero aunque el uso IA sea menor al presupuesto si el crédito propio se usó en otro período.',
  'aiBilling.periods.tooltip.crossPeriodMovements':
    'Créditos de este período aplicados a otros, o recibidos desde grants de otros períodos.',

  'aiBilling.period.status.active': 'Activo',
  'aiBilling.period.status.closed': 'Cerrado',
  'aiBilling.period.status.blocked': 'Bloqueado',

  'aiBilling.grants.columns.period': 'Periodo',
  'aiBilling.grants.columns.balance': 'Disponible / original',
  'aiBilling.grants.columns.originalAmount': 'Monto original',
  'aiBilling.grants.columns.remainingAmount': 'Monto disponible',
  'aiBilling.grants.columns.currency': 'Moneda',
  'aiBilling.grants.columns.validFrom': 'Válido desde',
  'aiBilling.grants.columns.expiresAt': 'Expira',
  'aiBilling.grants.columns.reason': 'Motivo',

  'aiBilling.grants.recharge': 'Recargar',
  'aiBilling.grants.rechargeCredits': 'Recargar créditos',
  'aiBilling.grants.rechargeCredits.title': 'Recargar créditos IA',
  'aiBilling.grants.rechargeCredits.description':
    'Agrega saldo para el consumo de agentes IA en AUTOMY.',
  'aiBilling.grants.rechargeCredits.submit': 'Continuar al pago',
  'aiBilling.grants.rechargeCredits.error.missingCheckoutUrl':
    'No se recibió la URL de pago. Intenta nuevamente.',

  'aiBilling.grants.grantManual': 'Otorgar crédito manual',
  'aiBilling.grants.grantManual.description':
    'Usa esta opción solo para bonos, promociones, compensaciones o ajustes internos.',
  'aiBilling.grants.grantManual.submit': 'Otorgar crédito',
  'aiBilling.grants.usage.title': 'Uso del crédito',
  'aiBilling.grants.usage.description':
    'Consulte los movimientos de consumo asociados al crédito seleccionado.',
  'aiBilling.grants.usage.columns.billingOperationId': 'ID operación de facturación',
  'aiBilling.grants.usage.columns.aiConsumptionId': 'ID consumo AI',
  'aiBilling.grants.usage.columns.referenceKey': 'Clave de referencia',
  'aiBilling.grants.usage.columns.sequence': 'Secuencia',
  'aiBilling.grants.usage.columns.amount': 'Monto',
  'aiBilling.grants.fields.amount': 'Monto',
  'aiBilling.grants.fields.currency': 'Moneda',
  'aiBilling.grants.fields.isCustomerVisible': 'Visible para el cliente',
  'aiBilling.grants.fields.isRefundable': 'Reembolsable',
  'aiBilling.grants.fields.reason': 'Motivo',
  'aiBilling.grants.fields.internalComment': 'Comentario interno',
  'aiBilling.grants.fields.confirmedBy': 'Confirmado por',
  'aiBilling.grants.fields.associateToCurrentPeriod': 'Asociar al periodo actual',
  'aiBilling.grants.fields.validFrom': 'Válido desde',
  'aiBilling.grants.fields.expiresAt': 'Expira',

  'aiBilling.grant.type.planIncludedMonthlyCredit': 'Incluido en plan',
  'aiBilling.grant.type.promotionalCredit': 'Promocional',
  'aiBilling.grant.type.manualBonus': 'Bono manual',
  'aiBilling.grant.type.supportCompensation': 'Compensación soporte',
  'aiBilling.grant.type.paidCredit': 'Crédito pagado',
  'aiBilling.grant.type.adjustment': 'Ajuste',
  'aiBilling.grant.type.purchaseOrderCredit': 'Orden de compra',

  'aiBilling.consumptionLedgerKind.includedCredit': 'Crédito incluido',
  'aiBilling.consumptionLedgerKind.promotionalCredit': 'Promocional',
  'aiBilling.consumptionLedgerKind.paidCredit': 'Crédito pagado',
  'aiBilling.consumptionLedgerKind.billable': 'Facturable',
  'aiBilling.consumptionLedgerKind.billableSettlement': 'Liquidación facturable',
  'aiBilling.consumptionLedgerKind.purchaseOrderCredit': 'Orden de compra',
};
